import React from 'react';

const CacheHOC = (ParentComponent, id) =>
  class Cache extends ParentComponent {
    constructor(props) {
      super(props);
      this.globalThis = window;
      this.cacheId =  props.location.query.isRecharge === 'true' ? id + 'Recharge' : id;
    }
    getData = () => {
      return this.globalThis.projectCache[this.cacheId];
    };

    setData = value => {
      if (!value) return (this.globalThis.projectCache[this.cacheId] = null);
      const newState = {
        ...(this.getData() || {}),
        ...value
      };
      this.globalThis.projectCache[this.cacheId] = newState;
    };
    setScroll = value => {
      this.globalThis.scrollCache[this.cacheId] = value;
    };
    getScroll = () => {
      return this.globalThis.scrollCache[this.cacheId];
    };
    getScrollElement = () => {
      const docHeight = document.documentElement.clientHeight
      const docume =  document.documentElement.getBoundingClientRect().height>docHeight?document.documentElement:document.body;
      return document.querySelector(`#${this.cacheId}`)||docume;
    };
    init = () => {
      if (!this.globalThis.projectCache) this.globalThis.projectCache = {};
      if (!this.globalThis.scrollCache) this.globalThis.scrollCache = {};
      if (!this.globalThis.refreshCache) this.globalThis.refreshCache = {};
      if (this.props.location.action !== 'POP') {
        this.setData(null);
        this.setScroll('');
        this.update(false);
      }
    };
    update = value => {
      this.globalThis.refreshCache[this.cacheId] = value;
    };
    isUpdate = () => {
      return this.globalThis.refreshCache[this.cacheId];
    };
    componentDidMount() {
      const superComponentDidMount = super.componentDidMount;
      this.init();
      if (this.isUpdate()) {
        this.setState(this.getData(), () => {
          superComponentDidMount && superComponentDidMount.call(this);
          // this.getScrollElement()
          //   ? (this.getScrollElement().scrollTop = this.getScroll())
          //   : (document.body.scrollTop = this.getScroll());
          this.getScrollElement()&&(this.getScrollElement().scrollTop=this.getScroll())
          this.update(false);
          document.body.scrollTo(0, this.getScroll());
        });
      } else {
        if (this.getData()) {
          this.setState(this.getData(), () => {
            this.getScrollElement()&&(this.getScrollElement().scrollTo=this.getScroll())
            document.body.scrollTo(0, this.getScroll());
          });
        } else {
          superComponentDidMount && superComponentDidMount.call(this);
        }
      }
    }
    componentWillUnmount() {
      this.setData(this.state);
      this.setScroll(
        (this.getScrollElement() && this.getScrollElement().scrollTop) ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
      );
      const superComponentWillUnmount = super.componentWillUnmount;
      superComponentWillUnmount && superComponentWillUnmount.call(this);
    }
    render() {
      return (
        <div id={this.cacheId + 'hxcf'} style={{ height: '100%' }}>
          {super.render()}
          {/* {React.cloneElement(super.render(),{onDraw:this.onDraw})} */}
          {/* 将缓存数据和修改缓存数据的方法传递给该缓存组件传入的子组件中 */}
          {/* {React.cloneElement(this.props.children, { cache:this.state.cache, onDraw:this.onDraw })} */}
        </div>
      );
    }
  };

export default CacheHOC;



// WEBPACK FOOTER //
// ./src/components/HOC/StateCache.js